import Form from "./../../constant/Forms";
import axios from "axios";

export default {
  name: "RegistrationFormComponent",
  props: {
    index: String,
    user: String,
    returnButtonName: String,
  },

  data() {
    return {
      employeeForm: Form.EMPLOYEE_FORM,
      polishStudentForm: Form.POLISH_STUDENT_FORM,
      foreignStudentForm: Form.FOREIGN_STUDENT_FORM,
      displayEmployeeForm: false,
      displayPolishStudentForm: false,
      displayForeignStudentForm: false,
      readyEmployeeForm: {},
      readyPolishStudentForm: {},
      readyForeignStudentForm: {},
      dateMenu: false,
      submitButtonName: "",
      showPassword: false,
      showRepeatPassword: false,
      errorPasswordMessages: "",
      errorRepeatPasswordMessages: "",
      form: "",
      info: null,
      snackbar: false,
      snackbarText: "",
      snackbarUid: "",
      snackbarColor: "#439E69",
      isButtonActive: false,
    };
  },
  watch: {
    dateMenu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    repeatPassword() {
      this.errorPasswordMessages = "";
      this.errorRepeatPasswordMessages = "";
    },
  },
  methods: {
    displayProperForm() {
      if (this.user == "employee") {
        this.displayEmployeeForm = true;
        this.form = this.employeeForm;
        this.formTypeName = "employee";
      } else if (this.user == "polishStudent") {
        this.displayPolishStudentForm = true;
        this.form = this.polishStudentForm;
        this.formTypeName = "polishStudent";
      } else if (this.user == "foreignStudent") {
        this.displayForeignStudentForm = true;
        this.form = this.foreignStudentForm;
        this.formTypeName = "foreignStudent";
      } else this.$router.push("/");

      this.getRegistrationTitle();
      this.getRegistrationText();
      this.setButtonName();
    },

    getRegistrationTitle() {
      if (this.displayForeignStudentForm == true) return "Registration";
      else return "Rejestracja";
    },

    getRegistrationText() {
      if (this.displayForeignStudentForm == true)
        return "The form below allow you to set up an account";
      else return "Poniższy formularz umożliwia założenie konta";
    },

    checkPassword() {
      if (
        this.form.repeatPassword !== "" &&
        this.form.password !== this.form.repeatPassword
      ) {
        if (this.displayForeignStudentForm == true)
          this.errorPasswordMessages =
            '"Password" and "Repeat password" fields must be the same';
        else
          this.errorPasswordMessages =
            'Pola "Hasło" oraz "Powtórz hasło" muszą być takie same';
      } else this.errorPasswordMessages = "";

      return true;
    },

    checkRepeatPassword() {
      if (
        this.form.password !== "" &&
        this.form.repeatPassword !== this.form.password
      ) {
        if (this.displayForeignStudentForm == true)
          this.errorRepeatPasswordMessages =
            '"Password" and "Repeat password" fields must be the same';
        else
          this.errorRepeatPasswordMessages =
            'Pola "Hasło" oraz "Powtórz hasło" muszą być takie same';
      } else this.errorRepeatPasswordMessages = "";

      return true;
    },

    saveFormData() {
      const version = "2.8"; //form version needed for backend validation

      if (this.employeeForm.valid) {
        return (this.readyEmployeeForm = {
          name: this.employeeForm.name,
          surname: this.employeeForm.surname,
          pesel: this.employeeForm.pesel,
          password: this.employeeForm.password,
          formType: this.formTypeName,
          version: version,
        });
      }

      if (this.polishStudentForm.valid) {
        return (this.readyPolishStudentForm = {
          name: this.polishStudentForm.name,
          surname: this.polishStudentForm.surname,
          index: this.polishStudentForm.index,
          pesel: this.polishStudentForm.pesel,
          email: this.polishStudentForm.privateMail,
          password: this.polishStudentForm.password,
          formType: this.formTypeName,
          version: version,
        });
      }

      if (this.foreignStudentForm.valid) {
        return (this.readyForeignStudentForm = {
          name: this.foreignStudentForm.name,
          surname: this.foreignStudentForm.surname,
          index: this.foreignStudentForm.index,
          passport: this.foreignStudentForm.idCard,
          email: this.foreignStudentForm.privateMail,
          birth: this.foreignStudentForm.birthDate,
          password: this.foreignStudentForm.password,
          formType: this.formTypeName,
          version: version,
        });
      }
    },

    saveDate(date) {
      this.$refs.dateMenu.save(date);
    },

    setButtonName() {
      if (this.user == "foreignStudent") this.submitButtonName = "Register";
      else this.submitButtonName = "Zarejestruj";
    },

    // validatePass: function () {
    //     console.log(this.password.value === this.repeatPassword.value)
    // },

    validate() {
      this.isButtonActive = true; // disable button after sending form

      if (this.$refs.form.validate()) {
        let readyFormData = new FormData();

        readyFormData.append("name", this.saveFormData().name);
        readyFormData.append("surname", this.saveFormData().surname);
        readyFormData.append("password", this.saveFormData().password);
        readyFormData.append("formType", this.saveFormData().formType);
        readyFormData.append("version", this.saveFormData().version);

        if (this.employeeForm.valid) {
          readyFormData.append("pesel", this.saveFormData().pesel);
          readyFormData.append("requestedFormType", "PR-RE");
        } else if (this.polishStudentForm.valid) {
          readyFormData.append("requestedFormType", "ST-RE");
          readyFormData.append("pesel", this.saveFormData().pesel);
          readyFormData.append("index", this.saveFormData().index);
          readyFormData.append("dowod", this.saveFormData().dowod);
          readyFormData.append("email", this.saveFormData().email);
        } else if (this.foreignStudentForm.valid) {
          readyFormData.append("requestedFormType", "ED-RE");
          readyFormData.append("index", this.saveFormData().index);
          readyFormData.append("passport", this.saveFormData().passport);
          readyFormData.append("email", this.saveFormData().email);
          readyFormData.append("birth", this.saveFormData().birth);
        }
        //test end

        axios
          .post("https://csa.umw.edu.pl/app/index.php", readyFormData)
          .then((res) => this.preparePopup(res.data))
          .catch((error) => console.log(error))
          .then(() => this.enableButton()); // enable button when sending form failes
      } else {
        this.preparePopup("invalidForm");
        this.isButtonActive = false; // enable button when sending form failes
      }
    },

    enableButton() {
      this.isButtonActive = false;
    },

    preparePopup(res) {
      console.log(res);

      this.snackbar = true;
      if (res.error == "01") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "Please fill out all required information.";
        } else
          this.snackbarText = "Proszę uzupełnić wszystkie wymagane informacje.";
        this.snackbarColor = "#C14348";
      } else if (res.error == "02") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "Error. Please try again.";
        } else
          this.snackbarText =
            "Wystąpił błąd podczas tworzenia konta. Proszę spróbować ponownie.";
        this.snackbarColor = "#C14348";
        // this.$refs.form.reset();
      } else if (res.error == "03") {
        if (this.user == "foreignStudent") {
          this.snackbarText =
            "Provided name or surname doesn't match. Please try again";
        } else
          this.snackbarText =
            "Wprowadzono błędne dane. Proszę spróbować ponownie.";
        this.snackbarColor = "#C14348";
      } else if (res.error == "04") {
        if (this.user == "foreignStudent") {
          this.snackbarText =
            "Error. Please try again or contact admin@umw.edu.pl";
        } else
          this.snackbarText =
            "Wystąpił błąd podczas tworzenia konta. Proszę spróbować ponownie później lub kontaktować się na admin@umw.edu.pl";
        this.snackbarColor = "#C14348";
        // this.$refs.form.reset();
      } else if (res.error == "05") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "This account already exist.";
        } else
          this.snackbarText = "Konto, które próbujesz utworzyć, już istnieje.";
        this.snackbarColor = "#C14348";
        // this.$refs.form.reset();
      } else if (res.error == "06") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "Unit not found. Contact admin@umw.edu.pl";
        } else
          this.snackbarText =
            "Wystąpił problem ze znalezieniem podanej jednostki - konto nie zostało utworzone. Prosimy o kontakt na admin@umw.edu.pl";
        this.snackbarColor = "#C14348";
        // this.$refs.form.reset();
      } else if (res.error == "07") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "Account created. Login:";
        } else
          this.snackbarText = "Konto zostało utworzone. Nazwa użytkownika:";
        //   "Formularz rejestracji został wysłany poprawnie. Konto zostało utworzone.";
        this.snackbarUid = res.uid;
        this.snackbarColor = "#439E69";
        // this.$refs.form.reset();
      } else if (res.error == "08") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "Error. Please try again.";
        } else
          this.snackbarText =
            "Wystąpił błąd podczas tworzenia konta. Proszę spróbować ponownie.";
        this.snackbarColor = "#C14348";
        // this.$refs.form.reset();
      } else if (res.error == "09") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "This account already exist.";
        } else
          this.snackbarText = "Konto, które próbujesz utworzyć, już istnieje.";
        this.snackbarColor = "#C14348";
        // this.$refs.form.reset();
      } else if (res.error == "10") {
        if (this.user == "foreignStudent") {
          this.snackbarText =
            "Error. Try again later or contact admin@umw.edu.pl";
        } else
          this.snackbarText =
            "Wystąpił błąd podczas tworzenia konta. Proszę spróbować ponownie później lub kontaktować się na admin@umw.edu.pl";
        this.snackbarColor = "#C14348";
        // this.$refs.form.reset();
      } else if (res.error == "11") {
        if (this.user == "foreignStudent") {
          this.snackbarText =
            "Error. Try again later or contact admin@umw.edu.pl";
        } else
          this.snackbarText =
            "Wystąpił błąd podczas tworzenia konta. Proszę spróbować ponownie później lub kontaktować się na admin@umw.edu.pl";
        this.snackbarColor = "#C14348";
        // this.$refs.form.reset();
      } else if (res.error == "15") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "Wrong version. Refresh browser and try again.";
        } else
          this.snackbarText =
            "Niezgodna wersja. Odśwież przeglądarkę i spróbuj ponownie";
        this.snackbarColor = "#C14348";
        // this.$refs.changePasswordForm.reset();
      } else if (res.error == "99") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "Wrong version. Refresh browser and try again.";
        } else
          this.snackbarText =
            "Niezgodna wersja. Odśwież przeglądarkę i spróbuj ponownie";
        this.snackbarColor = "#C14348";
        // this.$refs.changePasswordForm.reset();
      } else if (res == "invalidForm") {
        if (this.user == "foreignStudent") {
          this.snackbarText = "Error. Please fill all fields.";
        } else
          this.snackbarText = "Proszę uzupełnić wszystkie wymagane informacje.";
        this.snackbarColor = "#C14348";
      } else if (!res.error) {
        if (this.user == "foreignStudent") {
          this.snackbarText =
            "Error. Try again later or contact admin@umw.edu.pl";
        } else
          this.snackbarText =
            "Wystąpił błąd podczas tworzenia konta. Proszę spróbować ponownie później lub kontaktować się na admin@umw.edu.pl";
        this.snackbarColor = "#C14348";
        // this.$refs.form.reset();
      } else if (res.error == "23") {
        if (this.user == "foreignStudent") {
          this.snackbarText =
            "Incorrect Passport number or Identity Card, go to dean's Office, ask for correction on Virtual University system";
        } else
          this.snackbarText =
            "Błędny PESEL lub numer dowodu - skontaktuj się z dziekanatem";
        this.snackbarColor = "#C14348";
        // this.$refs.form.reset();
      } else if (res.error == "33") {
        if (this.user == "foreignStudent") {
          this.snackbarText = res.msg;
        } else this.snackbarText = res.msg;
        this.snackbarColor = "#C14348";
        // this.$refs.form.reset();
      } else if (res.error == "33") {
        if (this.user == "employee") {
          this.snackbarText = res.msg;
        } else this.snackbarText = res.msg;
        this.snackbarColor = "#C14348";
        // this.$refs.form.reset();
      } else if (res.error == "33") {
        if (this.user == "polishStudent") {
          this.snackbarText = res.msg;
        } else this.snackbarText = res.msg;
        this.snackbarColor = "#C14348";
        // this.$refs.form.reset();
      }
    },
  },
  created() {
    this.displayProperForm();
  },
};
